import {
    Box,
    Stack,
    Heading,
    Text,
    Button,
    useDisclosure,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerOverlay
} from '@chakra-ui/react'

import useRegisterChild from '../hooks/useRegisterChild'
import RegisterChildForm from './RegisterChildForm'

export default function RegisterChild() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const { handleSubmit, register, errors, isSubmitting } = useRegisterChild(onClose)

    return (
        <>
            <Button colorScheme="brand" size={'lg'} onClick={onOpen}>
                Add Children
            </Button>
            <Drawer isOpen={isOpen} placement="right" onClose={onClose} size={'md'}>
                <DrawerOverlay />
                <DrawerContent pt={16}>
                    <DrawerCloseButton />
                    <DrawerBody>
                        <Stack textAlign={'center'} mb="4">
                            <Heading fontSize={'2xl'}>Add new child</Heading>
                            <Text fontSize={{ base: 'sm', sm: 'md' }} color={'gray.600'}>
                                Provide your child information
                            </Text>
                        </Stack>

                        <Box rounded={'lg'} bg={'white'}>
                            <RegisterChildForm
                                onSubmit={handleSubmit}
                                register={register}
                                errors={errors}
                                isSubmitting={isSubmitting}
                            />
                        </Box>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    )
}
